import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  ErrorStateMatcher
} from '@angular/material';
import {
  FormControl,
  FormGroupDirective,
  NgForm,
  ValidatorFn,
  AbstractControl
} from '@angular/forms';

@Component({
  selector: 'app-modal-nombre-corto',
  templateUrl: './modal-nombre-corto.component.html',
  styleUrls: ['./modal-nombre-corto.component.css']
})
export class ModalNombreCortoComponent implements OnInit {
  // Loading
  loading;
  step = 'init';

  // Data
  empresa;
  empresas;

  siglaFormControl = new FormControl('', []);
  matcher = new MyErrorStateMatcher();

  constructor(
    public dialogRef: MatDialogRef<ModalNombreCortoComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.empresa = data.empresa;
    this.empresas = data.empresas;
  }

  ngOnInit() {
    this.siglaFormControl.setValidators([
      this.nombreCortoValidator(this.empresas)
    ]);
  }

  nombreCortoValidator(empresas): ValidatorFn {
    return (control: any): { [key: string]: any } | null => {
      for (const empresaI of empresas) {
        if (empresaI.sigla === control.value) {
          return { nombreRepetido: true };
        }
      }
      return { nombreRepetido: false };
    };
  }

  cancel(): void {
    this.dialogRef.close();
  }

  aceptar() {
    this.data.callback(this.empresa.idEmpresa, this.siglaFormControl.value);
  }

  ok() {
    this.dialogRef.close(true);
  }
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.hasError('nombreRepetido') &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}
